module.exports = __webpack_public_path__ + "static/media/welcome-profile.4113c5b4.png";